import APIService from "@/services/APIService.js";

export default {
  consultarDescricoesUcs(postData) {
    return APIService.apiCall().post(
      "/tucagem/consultar",
      JSON.stringify({ ...postData }),
      { responseType: "blob" }
    );
  }
};
